import { RoutePath } from 'enums/Routes';
import AvailableShifts from 'components/FinancialCheckup/AvailableShifts';
import ShiftDetails from 'components/FinancialCheckup/ShiftDetails';

import { RouterType } from './types';

export const getShiftsRoutes = (): RouterType => ({
  [RoutePath.AvailableShifts]: {
    navigationInfo: { showBackLink: true, title: 'Shifts' },
    component: AvailableShifts,
  },
  [RoutePath.ShiftDetails]: {
    navigationInfo: { showBackLink: true, title: 'Shift details' },
    component: ShiftDetails,
  },
});
